import { lazy, Suspense } from 'react';

import { useMessageDialogStore } from '../../store';

// Lazy-loaded so the TipTap editor stack (~114 KB) only downloads when the
// compose/reply/forward dialog is actually opened — not on every page load.
const MessageDialog = lazy(() =>
  import('../../pages/private/Inbox/components/MessageDialog').then(
    (module) => ({ default: module.MessageDialog }),
  ),
);

export function GlobalMessageDialog() {
  const isOpen = useMessageDialogStore((state) => state.isOpen);
  const close = useMessageDialogStore((state) => state.close);
  const dialogKey = useMessageDialogStore((state) => state.dialogKey);
  const messageId = useMessageDialogStore((state) => state.messageId);
  const draftId = useMessageDialogStore((state) => state.draftId);
  const selectedHandlerButton = useMessageDialogStore(
    (state) => state.selectedHandlerButton,
  );
  const inboxEntryId = useMessageDialogStore((state) => state.inboxEntryId);
  const scheduledEmail = useMessageDialogStore((state) => state.scheduledEmail);
  const composeToRecipients = useMessageDialogStore(
    (state) => state.composeToRecipients,
  );
  const aiAssisted = useMessageDialogStore((state) => state.aiAssisted);
  const prefill = useMessageDialogStore((state) => state.prefill);
  const onSent = useMessageDialogStore((state) => state.onSent);

  if (!isOpen) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <MessageDialog
        key={dialogKey}
        dialogId={String(dialogKey)}
        onClose={close}
        messageId={messageId}
        draftId={draftId}
        selectedHandlerButton={selectedHandlerButton}
        onResetHandler={close}
        inboxEntryId={inboxEntryId}
        scheduledEmail={scheduledEmail}
        composeToRecipients={composeToRecipients}
        aiAssisted={aiAssisted}
        prefill={prefill}
        onSent={onSent}
      />
    </Suspense>
  );
}
